import { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';

type FormWithEmploymentTypeCheckboxes = {
  isFreelance: boolean | undefined;
  isTempwork: boolean | undefined;
  isEmployee: boolean | undefined;
  mutableUntilHours: string | undefined;
  hourlyRate: string | undefined;
  cla: string | undefined;
};

export const useFormEmploymentCheckboxes = () => {
  const { trigger, unregister } = useFormContext<FormWithEmploymentTypeCheckboxes>();

  const triggerEmployementCheckboxes = useCallback(async () => {
    await Promise.all([trigger('isFreelance'), trigger('isTempwork'), trigger('isEmployee')]);
  }, []);

  const triggerFreelanceCheckbox = useCallback(async () => {
    triggerEmployementCheckboxes();
    unregister('mutableUntilHours');
    unregister('hourlyRate');
    await Promise.all([trigger('mutableUntilHours'), trigger('hourlyRate')]);
  }, []);

  const triggerTempworkCheckbox = useCallback(async () => {
    triggerEmployementCheckboxes();
    unregister('cla');
    await trigger('cla');
  }, []);

  const triggerEmployeeCheckbox = useCallback(async () => {
    triggerEmployementCheckboxes();
    await Promise.all([trigger('mutableUntilHours'), trigger('hourlyRate'), trigger('cla')]);
  }, []);

  return {
    triggerFreelanceCheckbox,
    triggerTempworkCheckbox,
    triggerEmployeeCheckbox,
  };
};
